import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

import 'element-ui/lib/theme-chalk/index.css';
import './style/index.css';

import { CountDown, Dialog, Image } from 'vant';

import {
  Select,
  Option,
  Drawer,
  Form,
  Input,
  Button,
  RadioGroup,
  Radio,
  Tooltip,
  Dialog as ElDialog,
  Alert
} from 'element-ui';

Vue.use(CountDown);
Vue.use(Dialog);
Vue.use(Image);

Vue.use(Select);
Vue.use(Option);
Vue.use(Drawer);
Vue.use(Form);
Vue.use(Input);
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Tooltip);
Vue.use(ElDialog);
Vue.use(Alert);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
